const messages = {
  currencyInput: {
    helpText: {
      id: 'admin/promotions.form.buy-and-win.benefit.max-price.help-text',
    },
  },
  validation: {
    gt: {
      id: 'admin/promotions.form.validation.greater-than',
    },
  },
}

export default messages
